import { useEffect, useLayoutEffect, useState } from "react"
import { useForm } from "react-hook-form";
import { subscribe, useSnapshot } from "valtio"
import Api from "../state/Api"
import { AgmodalStore, bookingsStore, configStore, contractsStore, entityStore, EntityV2Store, loginStore, quoteDataRec } from "../state/CommonState"
import { Cargo, Container, enquiryStore } from "../enquiry/enquiry-data"
import EnquiriesApi from "../state/enq-api"
import Utils from "../util/Utils"
import { CarrierWebView2v3 } from "./carrierweb-view-v3"
import { useGlobalState } from "../GlobalState"
import { AgInput } from "../components/AgComponents"
import MonApi from "../state/mongo-api"
import TaskTrigger from "../mytasks/task-trigger"
import VendorAssignment from "../mytasks/vendor-assignment-form"
import { taskStore } from "../mytasks/task-store"
import { Task } from "../mytasks/tasks-api"
import Newapi from "../state/new-api"
import { myactionsstore } from "../my-actions/store-myactions"
import { Visibility } from "../my-actions/visibility"
import { VisibilityGraph } from "../my-actions/visibilitygraph"
import BookingSchedule from "../pricing/booking.schedule"
import RoleUtils from "../util/RoleUtils";
import { PERMISSIONS, PERMISSIONS_NEW } from "../util/constants";
import ActrejectModal6 from "./enquirysuggestion-v3"
import CarrierWebView1v3 from "./carrierweb-view-v3"
import AguserApi from "../state/AguserApi"
import { IconButton } from "@mui/material"
import EntityV2Api from "../state/entities-api"
import backarrow  from "../assets/images/backarrow.svg";
import { Route } from "../v3-componets/AgRoute";
import { Details } from "../v3-componets/AgDetails";
import { loader } from "../util/loader";
import BookingsApi from "../state/bookings-api";
import AgNewModal from "../components/AgnewModal";
import EntityUtils from "../util/entityUtils";
import LoadERP from "../erp/LoadERP"
import EntityApi from "../state/entity-api";
import FCLChargeClientViewv3 from "./FCLChargeClientView-v3";
import AirChargesClientViewv3 from "./AirChargesClientView-v3";
import LCLChargeClientViewv3 from "./LCLChargeClientView-v3";
import Taskfiledisplay from "../mytasks/task-file-display";
import { rtpStore } from "../pricing/pricing-store";
import { DsrModal } from "../my-actions/dsrmodal";
import ContractDetails from "../v3-componets/ContractDetails";
import CartingOrderApi from "../state/cartingorder-api";

export default function ViewEnquiryv3(props) {
    const [space, setSpace] = useState('')
    const [openDocModal,setOpenDocModal] = useState(false)
    const [graphList, setGraphList] = useState([])
    const [checkgraphList, setCheckGraphList] = useState(false)
    const [isButtonClicked, setButtonClicked] = useState(false);
    const [cost, setCost] = useState(false);
    const [costdata, setCostdata] = useState({});
    const [show, setShow] = useState(false);
    const [prList, setPrList] = useState([])
    const [bookingType, setBookingType] = useState("")
    const [erpnumber, setErpnumber] = useState("NA")
    
    const [openHoldModel, setHoldModelClose] = useState(false);
    const [openblockBookingModel, setblockBookingModelClose] = useState(false);
    const [csref, setCsref] = useState("")

    const handleCargoOnHold = async (key, bookingId) => {
        loader.show();
        const result = Api.cargoOnHold({key, bookingId})
        loader.hide();
    }
    const handleBookingBlock = async (key, bookingId) => {
        loader.show();
        const result = Api.blockthisBooking({key, bookingId})
        loader.hide();
    }

    const getExchangerates = async( ) =>{
        await Api.getExchangerates()
      }
      const getpr = (d)=>{
        let l = d
        for (let i = 0; i < prList.length; i++) {
            if(d==prList[i]['email']){
                l = `${prList[i]['firstName']} ${prList[i]['lastName']} (${prList[i]['email']})`
            }
        }
        return l
    }
    useLayoutEffect(() => {
        getExchangerates()
        setTimeout(() => {
            setSpace(' ')
        }, 300);
        AguserApi.getUsers4role_new("Procurement", setPrList)
    }, [])
    useSnapshot(contractsStore)
    useSnapshot(enquiryStore)
    useSnapshot(configStore)
    useSnapshot(bookingsStore)
    useSnapshot(taskStore)
    useSnapshot(myactionsstore)
    useSnapshot(AgmodalStore)
    const [enabled, setEnabled] = useState(bookingsStore.current.cargoOnHold ? true : false);
    const [blockBooking, setBlockBooking] = useState(bookingsStore.current.blockbooking ? true : false);
    console.log("+=",enquiryStore)
    const cargoForm = useForm({
        defaultValues: {
            mode: "LCL",
            orginScope: false,
            destinationScope: false,
            originType: false,
            destinationType: false,
            showCargoDetailsOutGuage: false,
            showPalletLabel:false
        }
    })
    const getcost = async () =>{
        if(props.showbooking){
            let l = await MonApi.find("Myactions",{bookingNum:bookingsStore.current._id,actionName:"Update Cost",status:"COMPLETED"})
            if(l.length>0){
                if(cost==false){
                    setCost(true)
                }
                if(JSON.stringify(l[0])!=JSON.stringify(costdata)){
                    setCostdata(l[0])
                }
            }else{
                if(cost!=false){
                    setCost(false)
                }
            }
        }
    }
    useEffect(()=>{
        getcost()
    },[JSON.stringify(AgmodalStore),bookingsStore.current,taskStore.current,taskStore.triggerActionVisible])
    useEffect(()=>{
        loader.show()
        setBookingType(Utils.fetchBookingType(bookingsStore.current))
    },[])
    useEffect(()=>{
        if(bookingsStore.current.cartingsheetId!=undefined && bookingsStore.current.cartingsheetId.length>0){
            setValue("cartingorder",true)
            if(csref!=bookingsStore.current.cartingsheetId){
                setCsref(bookingsStore.current.cartingsheetId)
            }
        }
        if(csref.length==0 && bookingsStore.current.linkedCarting!=undefined && bookingsStore.current.linkedCarting.length>0 && csref!=bookingsStore.current.linkedCarting){
            setCsref(bookingsStore.current.linkedCarting)
        }
    },[bookingsStore.current])
    useEffect(()=>{
        if((enquiryStore.current._id != undefined && enquiryStore.current._id.length>0) || enquiryStore.current.enqRoute!=undefined && enquiryStore.current.enqRoute.origin != undefined && enquiryStore.current.enqRoute.origin.length>0){
            if(enquiryStore.current.shipmentType.length>3 && enquiryStore.current.shipmentType.toLowerCase().indexOf('fcl')!=-1){
                enquiryStore.current.shipmentType = 'FCL'
                setValue("mode",'FCL');
            }else{
                setValue("mode",enquiryStore.current.shipmentType);
            }
            if(enquiryStore.current.multidest==undefined){
                if(enquiryStore.current.containerDetails==undefined) enquiryStore.current.containerDetails = [new Container()]
                if(enquiryStore.current.cargoDetails==undefined) enquiryStore.current.cargoDetails = [new Cargo()]
                setValue("multidest", [
                    {
                        destination:enquiryStore.current.enqRoute.destination,
                        cargoDetails:enquiryStore.current.cargoDetails,
                    }
                ]);
                enquiryStore.current.multidest = [
                    {
                        destination:enquiryStore.current.enqRoute.destination,
                        cargoDetails:enquiryStore.current.cargoDetails,
                    }
                ]
            }else{
                setValue("multidest",enquiryStore.current.multidest)
            }
            if(props.showbooking){
                setValue("fbaalways","Yes")
            }else{
                setValue("fbaalways","No")
            }
            setValue("containerDetails",enquiryStore.current.containerDetails)
            setValue("origin",enquiryStore.current.enqRoute.origin)
            setValue("cargoreadinessdate",enquiryStore.current.enqRoute.cargoReadinessDate)
            setValue("scope",enquiryStore.current.shipmentScope)
            setValue("shipmentType",enquiryStore.current.shipmentType)
            setValue("customerreference",enquiryStore.current.enqRoute.customerReferenceNum)
            setValue("hazardous",enquiryStore.current.hazardous === "No" ? false :true)
            setValue("quoteClass",enquiryStore.current.quoteClass)
            setValue("packingGroup",enquiryStore.current.packingGroup)
            setValue("temperature",enquiryStore.current.temperature)
            setValue("cargoValue",enquiryStore.current.cargoValue)
            setValue("unnumber",enquiryStore.current.unnumber)
            setValue("nonStackable", enquiryStore.current.nonStackable === "No" ? false :true)
            setValue("temperatureControlled", enquiryStore.current.temperatureControlled === "No" ? false :true)
            setValue("minTemperature",enquiryStore.current.minTemperature)
            setValue("maxTemperature",enquiryStore.current.maxTemperature)
            setValue("stuffingType",enquiryStore.current.stuffingType)
            setValue("destuffingType",enquiryStore.current.destuffingType)
            setValue("status",enquiryStore.current.status)
            setValue("cargoDimensionUnit",enquiryStore.current.cargoDimensionUnit)
            setValue("enqRoute",enquiryStore.current.enqRoute)
            setValue("vehicledetails",enquiryStore.current.vehicles)
            setValue("isFba",enquiryStore.current.fba === "Yes" ? true :false)
            setValue("ior",enquiryStore.current.fbaIorRequired === "Yes" ? true :false)
            setValue("occ",enquiryStore.current.fbaOCC === "Yes" ? true :false)
            setValue("dcc",enquiryStore.current.fbaDCC === "Yes" ? true :false)
            setValue("survey",enquiryStore.current.fbaSurvey === "Yes" ? true :false)
            setValue("storageAtDestination",enquiryStore.current.fbaSAD === "Yes" ? true :false)
            setValue("palletizationandlabelling",enquiryStore.current.fbaPAL === "Yes" ? true :false)
            setValue("days",enquiryStore.current.fbaDays!=undefined?enquiryStore.current.fbaDays:0)
            setValue("pick_up_by_amazon",enquiryStore.current.pick_up_by_amazon === "Yes" ? true :false)
            if(AgmodalStore.modalPage=='ViewEnquiryBooking-v3'){
                setValue("overHeight",enquiryStore.current.overHeight === "Yes" ? true :false)
                setValue("overlength",enquiryStore.current.overlength === "Yes" ? true :false)
                setValue("topLoading",enquiryStore.current.topLoading === "Yes" ? true :false)
                setValue("fumigation",enquiryStore.current.fumigation === "Yes" ? true :false)
                setValue("headLoad",enquiryStore.current.headLoad === "Yes" ? true :false)
                setValue("doorLoad",enquiryStore.current.doorLoad === "Yes" ? true :false)
                setValue("reefer",enquiryStore.current.reefer === "Yes" ? true :false)
                setValue("overHeightValue",enquiryStore.current.overHeightValue)
                setValue("overlengthValue",enquiryStore.current.overlengthValue)
            }
            setShow(true)
            loader.hide()
        }
    },[enquiryStore.current])
    const { control, watch, register, setValue, handleSubmit, reset, clearErrors, formState, trigger, getFieldState } = cargoForm;
    const { changeCurrentMenu } = useGlobalState()
    const shipConsMigratDate = new Date("2024-05-28");
    const rec = contractsStore.current
    let e = enquiryStore.current
    let activeProduct = e.shipmentType.substr(0, 3).toLowerCase()
    console.log(enquiryStore.current)
    //console.log('>>>>>>>>>>>', rec, props.viewonly)
    /*if (!rec._id && props.viewonly) return <></>
    let title = `Create Booking - ${rec._id}`
    if (!props.viewonly) title = 'Enquiries'*/
    let title
    if (props.showbooking) {
        if (!bookingsStore.current.erpJobId) bookingsStore.current.erpJobId = ''
        // title = 'Booking Detail - ' + bookingsStore.current._id + '-' + bookingType
        title = 'Booking Detail - ' + bookingsStore.current._id
        configStore.homescreenCurrentShipmentScope = contractsStore.current.shipmentScope
    } else {
        title = 'Enquiry Detail - ' + enquiryStore.current._id
    }
    let displayCargo4fcl = false
    {
        let e = enquiryStore.current
        let stype = e.shipmentType.substr(0, 3).toLowerCase()
        configStore.homescreenCurrentShipmentType = stype
        if (stype === 'fcl' && e.shipmentScope === 'Port-to-Door') {
            displayCargo4fcl = Utils.outGaugeContainerCheck(enquiryStore.current.containerDetails)
            if (e.destuffingType === 'Dock')
                displayCargo4fcl = true
        }
        else if (stype === 'fcl' && e.shipmentScope === 'Door-to-Port') {
            displayCargo4fcl = Utils.outGaugeContainerCheck(enquiryStore.current.containerDetails)
            if (e.stuffingType === 'Dock')
                displayCargo4fcl = true
        }
        else if (stype === 'fcl' && e.shipmentScope === 'Door-to-Door') {
            displayCargo4fcl = true
            if (e.stuffingType === 'Factory' && e.destuffingType === 'Factory')
                displayCargo4fcl = Utils.outGaugeContainerCheck(enquiryStore?.current?.containerDetails)
        }else if(stype==='fcl'){
            displayCargo4fcl = Utils.outGaugeContainerCheck(enquiryStore.current.containerDetails)
        }

        //console.log('#########>>>', stype, displayCargo4fcl)
    }
    const updatecusref = (e) =>{
        if(props.showbooking && rec['customerReferenceNum']!=e){
            rec['customerReferenceNum'] = e
            BookingsApi.setcustrefBooking(bookingsStore.current._id, rec)
        }
    }

    useEffect(() => {
        Promise.all([
            new Promise((resolve) => EntityApi.GetErpId('booking', bookingsStore.current._id, resolve)),
            new Promise((resolve) => EntityApi.GetErpId('job', bookingsStore.current._id, resolve))
        ]).then(([bookingData, jobData]) => {
            setErpnumber(bookingData.erpId || jobData.erpId || "NA");
        }).catch(() => {
            setErpnumber("NA");
        });

    }, [erpnumber]);
    
    useEffect(() => {
        console.log('*** subscribing ***********')
        const unsubscribe = subscribe(myactionsstore, () => {
            let graphList1 = []
            for (let i = 0; i < myactionsstore.list.length; i++) {
                let rec = myactionsstore.list[i]
                if (rec['booking']['containershow'] == undefined) {
                    rec['booking']['containershow'] = -1
                }
                let oneGraph = []
                console.log("the rec is ",rec)
                oneGraph = Visibility.GraphLine(rec)
                // console.log("oneGraph",i+1,oneGraph);
            if (rec?.icegateResData && rec?.icegateResData?.oocDt) {
                oneGraph[oneGraph?.length-1].r7 = `OOC ${Utils.convertICEGATEDate(rec?.icegateResData?.oocDt,2)}`
            }
            if (rec?.icegateResData && rec?.icegateResData?.leoDt) {
                oneGraph[0].r7 =`LEO ${Utils.convertICEGATEDate(rec?.icegateResData?.leoDt,2)}`
            }
                // if (rec.shipmentType !== 'Air') oneGraph = Visibility.oceanGraphLine(rec)
                // else oneGraph = Visibility.airGraphLine(rec)
                let activeOn = false
                let lastactive = -1
                for (let i = oneGraph.length - 1; i >= 0; i--) {
                    let node = oneGraph[i]
                    if(rec.status_closed == 'Y' || rec.status_closed == 'Yes' || rec.booking.status == 'ARCHIVED'){
                        node.isActive = true
                    }
                    if (node.isActive && !activeOn) {
                        node.activelines = 1
                        lastactive = i
                    }
                    if (node.isActive) activeOn = true
                    if (activeOn && !node.isActive) node.isActive = true
                    if (node.isActive && i < lastactive) node.activelines = 2
                }
                graphList1.push(oneGraph)
                console.log("graphList1",graphList1);
            }
            setGraphList(graphList1)
        })
        return unsubscribe
    }, [myactionsstore])
    if (graphList.length == 0) {

        console.log(myactionsstore)
        console.log(graphList)
        if (checkgraphList == false) {
            Newapi.getAllDsr4Displaybyid(bookingsStore.current._id)
            setCheckGraphList(true)
        }
    } else {

        console.log(myactionsstore)
        console.log(graphList)
    }

    useEffect(()=>{
        if(configStore.quotationModalVisible==false && graphList.length > 0){
            Newapi.getAllDsr4Displaybyid(bookingsStore.current._id)
        }
    },[configStore.quotationModalVisible])

    if (taskStore.triggerActionVisible) return <TaskTrigger />
    if (taskStore.vendorAssignment) return <VendorAssignment />
    if (taskStore.loadERP) return <LoadERP type={taskStore.loadERP}/>
    return (
        <>
        {
            taskStore.costmodal?<Costmodal rec={costdata} />:""
        }
        {
            configStore.cartingmodal?<Cartingmodal />:""
        }
        {
            show && <>
            <ActrejectModal6 type={"cancel"} id={e._id} />
            {space}
            <div className="columns ">
                <div className="column"  style={{display:"flex",justifyContent:"start",alignItems:"center"}}>
                { loginStore.isClient() &&  <IconButton disableRipple onClick={()=>{
                 bookingsStore.currentBookingsListComponent = "list"
            }}>
                <img src={backarrow}/>
            </IconButton> }
                    <h5 className="title is-4" style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, fontFamily: 'product_sans_bold' }}>
                        {title}
                    </h5>
                    <></>
                </div>
                <div className="column is-1">
                    {
                        // (props.showbooking && !loginStore.isClient() && RoleUtils.isUserAuthorized(PERMISSIONS.EDIT.BOOKING_VENDOR)) ?
                        (props.showbooking && !loginStore.isClient() && RoleUtils.isUserAuthorized(PERMISSIONS_NEW.BOOKINGS.ASSIGN_VENDOR)) ?
                            <button disabled={!bookingsStore.current.contract} style={{ marginTop: '10px' }} className="button islink"
                                onClick={async(e) => {
                                    // EntityV2Api.checkMyactionEnt(bookingsStore.current.entityId ,bookingsStore.current.branchId , (data) => {
                                    //     if(data.status === 200) {
                                    //         taskStore.current = new Task('')
                                    //     taskStore.current.initialize(bookingsStore.current, entityStore.entityRec)
                                    //     taskStore.vendorAssignment = true
                                    //     }
                                    //   } )
                                    taskStore.vendorAssignment = true
                                }}>Vendor</button>
                            : <></>
                    }
                </div>
                {
                        (props.showbooking && !loginStore.isClient() && cost) ?
                <div className="column is-1">
                    
                            <button disabled={!bookingsStore.current.contract} style={{ marginTop: '10px' }} className="button islink"
                                onClick={async(e) => {
                                    taskStore.costmodal=true
                                }}>Cost</button>
                            
                </div>: <></>
                    }
               <div className="column is-2">
     {
        props.showbooking && !loginStore.isClient() && RoleUtils.isUserAuthorized(PERMISSIONS_NEW.BOOKINGS.TRIGGER_ACTION) ? (
            <>
                <button
                    disabled={!bookingsStore.current.contract}
                    className="button is-link is-fullwidth"
                    style={{ marginBottom: '10px' }}
                    onClick={async (e) => {
                        taskStore.loadERP = 'job';
                    }}
                >
                    Job to ERP
                </button>
                { 'EXPORT' === Utils.fetchBookingType(bookingsStore.current).toUpperCase() &&
                <button
                    disabled={!bookingsStore.current.contract}
                    className="button is-link is-fullwidth"
                    onClick={async (e) => {
                        taskStore.loadERP = 'booking';
                    }}
                >
                    Booking to ERP
                </button>}
            </>
        ) : null
    } 
</div>

                <div className="column is-1">
                    {
                        (props.showbooking && !loginStore.isClient() && RoleUtils.isUserAuthorized(PERMISSIONS_NEW.BOOKINGS.TRIGGER_ACTION)) ?
                            <button disabled={!bookingsStore.current.contract} style={{ marginTop: '10px' }} className="button islink"
                                onClick={async(e) => {
                                    if(bookingsStore.listActiveTab === 'Shipments On Hold' || enabled){
                                        return configStore.setModalMessage('Cargo is on Hold')
                                    }
                                    if(EntityV2Store.EntityRec.customer.crossBorder.salesVertical !== 'MSME'){
                                        setOpenDocModal(true)
                                    }
                                    else{
                                        EntityV2Api.checkMyactionEnt(bookingsStore.current.entityId ,bookingsStore.current.branchId , (data) => {
                                        if(data.status === 200) {
                                            taskStore.current = new Task('')
                                            taskStore.current.initialize(bookingsStore.current, entityStore.entityRec)
                                            taskStore.triggerActionVisible = true
                                          }
                                        })
                                    }
                                   
                                }}>Action</button>
                            : <></>
                    }
                </div>
                <div className="column is-2">
                    {
                        (!loginStore.isClient() && props.showbooking) ?
                            <div style={!RoleUtils.isUserAuthorized(PERMISSIONS_NEW.BOOKINGS.UPDATE_JOB_NUMBER) ? { display: 'flex', justifyContent: 'center', pointerEvents: 'none', opacity: 0.6 } : { display: 'flex', justifyContent: 'center' }}>
                                <span>
                                    <AgInput placeholder={"FE-12350880-01"} label='ERP Job ref #' value={erpnumber} record={bookingsStore.current}
                                        name='erpJobId'/>
                                </span>
                                <span>
                                    <button className="button is-small islink"
                                        style={{ marginTop: '1rem' }}
                                        onClick={async () => {
                                            try {
                                                // if (!(/^([A-Z]){3}([/])([A-Z]){2}([/])\d{2}([/])\d{2}([/])([A-Z]){1}([/])\d{4}/.test(bookingsStore.current.erpJobId))) {
                                                //     configStore.setModalMessage('ERP Job ID is not valid.')
                                                //     return;
                                                // }
                                                if(bookingsStore.current.erpJobId!=undefined && bookingsStore.current.erpJobId.trim().length==0){
                                                    configStore.setModalMessage('ERP Job ID should not save as empty')
                                                    return;
                                                }
                                                let isBookingExistsWithSame = await MonApi
                                                    .find('Bookings', { erpJobId: bookingsStore.current.erpJobId }, { _id: 1 })
                                                    .then(res => Array.isArray(res) && res?.length > 0);
                                                if (isBookingExistsWithSame) {
                                                    configStore.setModalMessage('ERP Job ID with booking is already exists.')
                                                    return;
                                                }
                                                let ret = await MonApi.updateOne('Bookings',
                                                    { _id: bookingsStore.current._id },
                                                    { erpJobId: bookingsStore.current.erpJobId })
                                                if (ret.error) configStore.setModalMessage('' + ret.error)
                                                else configStore.setModalMessage('ERP Job ID updated successfully.')
                                            } catch (e) {
                                                configStore.setModalMessage('Error trying to save ERP ID')
                                            }
                                        }}>
                                        Save
                                    </button>
                                </span>
                            </div>
                            : <></>
                    }
                </div>
                <div className="column is-2">
                    {
                        (!loginStore.isClient() && props.showbooking) ?
                            <div style={!RoleUtils.isUserAuthorized(PERMISSIONS_NEW.BOOKINGS.UPDATE_BOOKING_NUMBER) ? { display: 'flex', justifyContent: 'center', pointerEvents: 'none', opacity: 0.6 } : { display: 'flex', justifyContent: 'center' }}>
                                <span>
                                    <AgInput label='ERP Booking #' record={bookingsStore.current}
                                        name='erpBookingId'/>
                                </span>
                                <span>
                                    <button className="button is-small islink"
                                        style={{ marginTop: '1rem' }}
                                        onClick={async () => {
                                            try {
                                                // if (!(/^([A-Z]){3}([/])([A-Z]){2}([/])\d{2}([/])\d{2}([/])([A-Z]){1}([/])\d{4}/.test(bookingsStore.current.erpJobId))) {
                                                //     configStore.setModalMessage('ERP Job ID is not valid.')
                                                //     return;
                                                // }
                                                if(bookingsStore.current.erpBookingId!=undefined && bookingsStore.current.erpBookingId.trim().length==0){
                                                    configStore.setModalMessage('ERP Booking ID should not save as empty')
                                                    return;
                                                }
                                                let isBookingExistsWithSame = await MonApi
                                                    .find('Bookings', { erpBookingId: bookingsStore.current.erpBookingId }, { _id: 1 })
                                                    .then(res => Array.isArray(res) && res?.length > 0);
                                                if (isBookingExistsWithSame) {
                                                    configStore.setModalMessage('ERP Booking ID with booking is already exists.')
                                                    return;
                                                }
                                                let ret = await MonApi.updateOne('Bookings',
                                                    { _id: bookingsStore.current._id },
                                                    { erpBookingId: bookingsStore.current.erpBookingId })
                                                if (ret.error) configStore.setModalMessage('' + ret.error)
                                                else configStore.setModalMessage('ERP Booking ID updated successfully.')
                                            } catch (e) {
                                                configStore.setModalMessage('Error trying to save ERP ID')
                                            }
                                        }}>
                                        Save
                                    </button>
                                </span>
                            </div>
                            : <></>
                    }
                </div>
            
               <div className="column is-2">
                    {
                        (!loginStore.isClient() && props.showbooking) ?
                            <div style={!RoleUtils.isUserAuthorized(PERMISSIONS_NEW.BOOKINGS.UPDATE_BOOKING_NUMBER) ? { display: 'flex', justifyContent: 'center', pointerEvents: 'none', opacity: 0.6 } : { display: 'flex', justifyContent: 'center' }}>
                    
                            <button disabled={!bookingsStore.current.contract} style={{ marginTop: '10px' }} className="button islink"
                                onClick={async(e) => {
                                    configStore.cartingmodal=true
                                }}>Carting Sheet</button>
                            </div>
                            : <></>
                    }
                </div>
                
                
            </div>
            {(props.showbooking && 
            (bookingsStore.listActiveTab === "Submitted Bookings" || bookingsStore.listActiveTab === "Shipments In-Progress"  || bookingsStore.listActiveTab === 'Shipments On Hold')) && 
                <div className="pl-4 pb-4 mb-2">
                    <span className="title is-5 mr-2" style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR_TERTIARY, fontFamily: 'product_sans_bold' }}>Make Cargo on {!enabled ? 'Hold?' : 'Release?'}</span>
                    <button
                        disabled={blockBooking}
                        type="button"
                        onClick={() => {
                            setEnabled(!enabled)
                            setHoldModelClose(true)
                        }}
                        className={`border-none relative inline-flex h-6 w-11 items-center rounded-full transition-colors duration-300 ${
                        enabled ? 'bg-blue-500' : 'bg-gray-300'
                        }`}
                        style={{ backgroundColor: enabled ? '#1976D2' : '#D4D4D4' }}
                    >
                        <span
                        className={`border-none inline-block h-4 w-4 transform rounded-full bg-white transition-transform duration-300 ${
                            enabled ? 'translate-x-6' : 'translate-x-1'
                        }`}
                        />
                    </button>
                    {
                        process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE === 'Navexel' ? 
                        <>
                            <span className="title is-5 ml-5 mr-2" style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR_TERTIARY, fontFamily: 'product_sans_bold' }}>Suppress Booking?</span>
                            <button
                                disabled={enabled}
                                type="button"
                                onClick={() => {
                                    setBlockBooking(!blockBooking)
                                    setblockBookingModelClose(true)
                                }}
                                className={`border-none relative inline-flex h-6 w-11 items-center rounded-full transition-colors duration-300 ${
                                blockBooking ? 'bg-blue-500' : 'bg-gray-300'
                                }`}
                                style={{ backgroundColor: blockBooking ? '#1976D2' : '#D4D4D4' }}
                            >
                                <span
                                className={`border-none inline-block h-4 w-4 transform rounded-full bg-white transition-transform duration-300 ${
                                    blockBooking ? 'translate-x-6' : 'translate-x-1'
                                }`}
                                />
                            </button>
                        </> : <></>
                    }
                    { openHoldModel &&
                        <div className='modal is-active' >
                            <div className="modal-background" ></div>
                                <div className="modal-card" onClick={(e) => { e.stopPropagation() }} style={{ borderRadius: '10px' }} >
                                <section className="modal-card-body">
                                <h2 style={{ color: "red" }}>Are you sure you want to keep cargo {enabled ? 'on hold?' : 'release?'}</h2>
                                    <br></br>
                                    <button type="submit" class="button is-danger" style={{ float: "right" }}
                                        onClick={async (e)=>{
                                            e.preventDefault();
                                            handleCargoOnHold(enabled, bookingsStore.current._id)
                                            setHoldModelClose(false)
                                            AgmodalStore.pageVisible = false;
                                            AgmodalStore.apiCall = true;
                                        }}
                                    >Yes</button>
                                    <button class="button is-warning" onClick={() => {
                                        setEnabled(!enabled)
                                        setHoldModelClose(false)
                                    }} >No</button>
                                </section>
                            </div>
                        </div>
                    }
                    { openblockBookingModel &&
                        <div className='modal is-active' >
                            <div className="modal-background" ></div>
                                <div className="modal-card" onClick={(e) => { e.stopPropagation() }} style={{ borderRadius: '10px' }} >
                                <section className="modal-card-body">
                                <h2 style={{ color: "red" }}>Are you sure you want to {blockBooking ? 'block' : 'unblock'} this Booking on Customer side?</h2>
                                    <br></br>
                                    <button type="submit" class="button is-danger" style={{ float: "right" }}
                                        onClick={async (e)=>{
                                            e.preventDefault();
                                            handleBookingBlock(blockBooking, bookingsStore.current._id)
                                            setblockBookingModelClose(false)
                                            AgmodalStore.pageVisible = false;
                                            AgmodalStore.apiCall = true;
                                        }}
                                    >Yes</button>
                                    <button class="button is-warning" onClick={() => {
                                        setBlockBooking(!blockBooking)
                                        setblockBookingModelClose(false)
                                    }} >No</button>
                                </section>
                            </div>
                        </div>
                    }
                </div>
                
            }
            { (openDocModal && props.showbooking) &&
                        <div className='modal is-active' >
                            <div className="modal-background" ></div>
                                <div className="modal-card" onClick={(e) => { e.stopPropagation() }} style={{ borderRadius: '10px' }} >
                                <section className="modal-card-body">
                                <h2 style={{ color: "black", textAlign:"center" }}>Document upload is available in the booking form. Do you want to continue with the action?</h2>
                                    <br></br>
                                    <button type="submit" class="button is-danger" style={{ float: "right" }}
                                        onClick={async (e)=>{
                                            e.preventDefault();
                                            EntityV2Api.checkMyactionEnt(bookingsStore.current.entityId ,bookingsStore.current.branchId , (data) => {
                                        if(data.status === 200) {
                                            taskStore.current = new Task('')
                                            taskStore.current.initialize(bookingsStore.current, entityStore.entityRec)
                                            taskStore.triggerActionVisible = true
                                          }
                                        })
                                            setOpenDocModal(false)
                                        }}
                                    >Proceed</button>
                                    <button class="button is-warning" onClick={() => {
                                        setOpenDocModal(false)
                                    }} >Cancel</button>
                                </section>
                            </div>
                        </div>
                    }
            <div className="columns">
                <div className="column is-12 m-0 p-0">
                <div className="w-full flex flex-col gap-[8px]">
       <form noValidate  style={{width:"100%",display:"flex",flexDirection:"column"}}>
       <div className="flex flex-row gap-[10px]">
        <div className="flex flex-col">  
       <Route form={cargoForm} viewonly={props.viewonly=='1'} callback={updatecusref}/>
       { props.showbooking === "1" && <button type="button" style={{ float: 'left', marginTop:"10px" }}
                                className="button is-rounded is-small islink" onClick={(e) => {
                                    e.stopPropagation();
                                    let customTC = []
                                    if (rec['customTC']) {
                                        customTC = rec['customTC'].split(/\r?\n/)
                                    }
                                    rec['tc']?.map(e => customTC.push(e))
                                    rec['temptc']?.map(e => customTC.push(e))
                                    configStore.setModalMessage("", [], false, customTC)
                                    // configStore.setModalMessage("hja")
                                }}>Terms and Conditions</button>}
        </div>
       <Details form={cargoForm} viewonly={props.viewonly=='1'}/> 
    
       </div>
       </form>
       </div>
                </div>
                
                
            </div>
                    {props.showbooking &&
                        !loginStore.isClient() &&
                        bookingsStore.current &&
                        bookingsStore.current.contract && (
                            <ContractDetails
                                procurement={bookingsStore.current.contract.procurement}
                                formatProcurement={getpr}
                                cartingDetails={bookingsStore.current.contract.cartingDetails}
                                agentDetails={bookingsStore.current.contract.agentDetails}
                                agentAddress={bookingsStore.current.contract.agentAddress}
                                alignRight={false}
                            />
                        )}

            {
                (props.showbooking && !loginStore.isClient() && bookingsStore.current.createdFromPricing && AgmodalStore.modalPage !== "ViewEnquiry-v3") ?
                    <BookingSchedule booking={bookingsStore.current} /> :
                    <></>
            }

            {
                (props.showbooking) ?
                    <div className="columns">
                        <div className="column is-12">
                            {
                                (new Date (bookingsStore.current.bookingDate) >= shipConsMigratDate)?
                                <CarrierWebView2v3 showbooking={props.showbooking} />:<CarrierWebView1v3 showbooking={props.showbooking} />
                            }
                        </div>
                    </div>
                    : <></>
            }
            {
                (e.status === 'CANCELLED') ? <div style={{ textAlign: 'center' }}>
                <strong>Reason:</strong> {e.reason}<br/>
                {e.remarks !== '' && (
                <span><strong>Remarks:</strong> {e.remarks}</span>
                )}                
                </div>
                :<></>
            }
            {
                (!props.showbooking) ?
                    (e.status !=='CANCELLED')?
                     <div className="columns">
                            <div className="column is-9">
                            {RoleUtils.isUserAuthorized(PERMISSIONS_NEW.ENQUIRIES.CANCEL_ENQUIRY) && (
                                <button style={{ float: 'right' }} className="button is-danger is-small is-rounded" onClick={() => {
                                    configStore.quotationModalVisible4 = true;
                                    AgmodalStore.apiCall = false;
                                }}>
                                    Cancel Enquiry</button>
                            )}
                            </div>
                            <div className="column is-3">
                            {RoleUtils.isUserAuthorized(PERMISSIONS_NEW.ENQUIRIES.GENERATE_QUOTATION_FROM_ENQUIRY) && (
                                <button style={{ float: 'right' }} disabled={isButtonClicked} onClick={() => {
                                    setButtonClicked(true);
                                    configStore.setModalMessage('Generating quotation from enquiry')
                                    EnquiriesApi.updateToQuote(e._id, () => {
                                        quoteDataRec.intialize()
                                        Api.getQuote(e._id)
                                        AgmodalStore.pageVisible = false;
                                        changeCurrentMenu('Quotationv3')
                                        AgmodalStore.modalPage = 'Quotev3';
                                        AgmodalStore.pageVisible = true;
                                    })

                                }}
                                    className="button is-small is-rounded islink">
                                    Generate Quotation from this Enquiry
                                </button>
                                )}
                            </div>
                        </div>:<></>
                    : <></>
            }

            {
                ((props.showbooking && graphList.length != 0)) ? <>
                    <hr />
                    <div>
                        <div className="box is-fullwidth">
                            {
                                graphList.map((e, i) => {
                                    let e1 = myactionsstore.list[i]
                                    return <VisibilityGraph graphNodes={e} dsrRec={e1} hideedit={false} />
                                })
                            }
                        </div>
                    </div>
                    {/* <h1 style={{textAlign:"center"}}><strong>DSR</strong></h1>
                    <ShipmentGraph graphNodes={graphList[0]} /> */}
                </> : <></>
            }
            </>
        }
        {
            configStore.quotationModalVisible && <DsrModal graphList={graphList} />
        }
        </>
    )
}

export function Costmodal(props) {
    useSnapshot(taskStore)
    console.log(props)
    let rec = props.rec
    let type = rec.shipmentType
    if(type!=undefined && type.indexOf("FCL") >= 0){
        type = "FCL"
    }
    let modalClass = 'modal'
    if (taskStore.costmodal) modalClass += ' is-active'
    return (
        <div className={modalClass} onClick={() => { taskStore.costmodal = false }}>
            <div className="modal-background" ></div>
            <div className="modal-card" onClick={(e) => { e.stopPropagation() }}
                style={{ borderRadius: '10px',width:"auto" }}>

                <dev className="modal-card-body" style={{ textAlign: 'center' }}>
                    <button className="delete" style={{ float: 'right' }}
                        onClick={() => { taskStore.costmodal = false }}></button>
                    <div>
                        {
                             (type.indexOf("FCL") >= 0)?<FCLChargeClientViewv3 dummyContract={rec}/> :<>
                             {
                                (type.indexOf("Air") >= 0)?<AirChargesClientViewv3 dummyContract={rec}/> :
                                <LCLChargeClientViewv3 dummyContract={rec}/> 
                             }
                             </>
                        }
                        <Taskfiledisplay notshow={true} validation={true} task={rec}/>
                    </div>
                </dev>
            </div>
        </div>
    )
}


function Cartingmodal() {
    useSnapshot(bookingsStore)
  let modalClass = "modal";
  if (configStore.cartingmodal) modalClass += " is-active";
  const [csref, setCsref] = useState("")
  useEffect(()=>{
    if(csref!=""){
        setCsref("")
    }
  },[configStore.cartingmodal])
  return (
    <div className={modalClass}>
      <div className="modal-background"></div>
      <div
        className="modal-card"
        onClick={(e) => {
          e.stopPropagation();
        }}
        style={{ borderRadius: "10px", width: "900px" }}
      >
        <section className="modal-card-body">
            <button className="delete" style={{ float: 'right' }}
                        onClick={() => { configStore.cartingmodal = false }}></button>
                        <br />
                        <div className="columns ">
                <div className="column is-4" >
                    <div className="control is-fullwidth">
                <input className="input is-small" value={csref} onChange={(e)=>{
                    setCsref(e.target.value)
                }} placeholder="Carting Sheet #" />
                </div>
                </div>
                <div className="column is-2" >
                    <button className="button is-small islink"
                                        onClick={async () => {
                                            try {
                                                
                                                if(csref!=undefined && csref.length==0){
                                                    configStore.setModalMessage('Carting Sheet Ref should not save as empty')
                                                    return;
                                                }
                                                let isBookingExistsWithSame = await MonApi
                                                    .find('CartingOrder', { _id: csref, status:"Carted"}, { _id: 1 })
                                                    .then(res => Array.isArray(res) && res?.length > 0);

                                                if (isBookingExistsWithSame) {
                                                    let callback = (d)=>{
                                                        if(bookingsStore.current.linkedCarting==undefined){
                                                            bookingsStore.current.linkedCarting = [csref]
                                                        }else{
                                                            bookingsStore.current.linkedCarting.push(csref)
                                                        }
                                                        configStore.setModalMessage('Carting Sheet Linked successfully.')
                                                        setCsref("")
                                                    }
                                                    CartingOrderApi.ClaimCartingorder({id:csref,bookingId:bookingsStore.current._id},callback)
                                                }else{
                                                    configStore.setModalMessage('Invalid Carting Sheet.')
                                                }
                                            } catch (e) {
                                                configStore.setModalMessage('Error trying to save Carting Sheet Ref #')
                                            }
                                        }}>
                                        Linked
                                    </button>
                </div>
                </div>
            <table>
        <tbody>
            {(bookingsStore.current.cartingsheetId!=undefined && bookingsStore.current.cartingsheetId.length>0)?
            <><tr>
                <td>
                    <strong>Claimed Carting</strong>
                </td>
            </tr>
            <tr>
                <td>
                    {bookingsStore.current.cartingsheetId}
                </td>
            </tr></>:""
            
            } {(bookingsStore.current.linkedCarting!=undefined && bookingsStore.current.linkedCarting.length>0)?
                <>
                <tr>
                <td>
                    <strong>Linked Carting</strong>
                </td>
            </tr>
            {
                bookingsStore.current.linkedCarting.map((v)=>{
                    return <tr>
                <td>
                    {v}
                </td>
            </tr>
                })
            }
                </>:""
            }
        </tbody>
    </table>
        </section>
      </div>
    </div>
  );
}